var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _polygon, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _polygon2, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _polygon3, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _polygon4, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _polygon5, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _circle, _circle2, _polygon6, _g4, _polygon7, _rect255, _rect256, _rect257, _polygon8, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _polygon9, _polygon0, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _polygon1, _rect474, _rect475, _line, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _polygon10, _rect586, _rect587, _rect588, _path3, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _polygon11, _polygon12, _polygon13, _rect619, _rect620, _rect621, _polygon14, _polygon15, _rect622, _polygon16, _polygon17, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _polygon18, _polygon19, _ellipse, _polygon20, _polygon21, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _polygon22, _polygon23, _polygon24, _polygon25, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _polygon26, _polygon27, _polygon28, _polygon29, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _polygon30, _polygon31, _rect672, _rect673, _rect674, _polygon32, _polygon33, _rect675, _polygon34, _polygon35, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _polygon36, _polygon37, _path4, _polygon38, _polygon39, _rect689, _rect690, _line2, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _polygon40, _polygon41, _polygon42, _polygon43, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _polygon44, _polygon45, _polygon46, _polygon47, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _polygon48, _polygon49, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _path5, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSanFrancisco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568.38 364.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1.95 -54.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.72,140.47c-11,13.36-19.45,28.61-27.83,43.76l-28.7,51.9c-7.3,13.19-14.77,26.95-15.63,42C5.6,294.9,13,311,21.48,325.48c11.32,19.34,25.17,37.6,43.23,50.87,30.64,22.5,70.09,28.48,107.92,32.2q66.3,6.52,133,6.62c20.12,0,40.39-.41,60.09-4.49,36.17-7.51,110.37-35,129.47-54.11,19.84-19.84,22.84-51.15,18.73-78.91C503,203.45,446.54,126,374.73,104.28,342,94.38,261.1,82.43,230.35,81,175.17,78.35,114.72,96.76,78.72,140.47Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 131.67,
    y1: 121.33,
    x2: 134.37,
    y2: 84.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 424.37,
    y1: 202.69,
    x2: 429.01,
    y2: 138.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 284.26,
    y1: 203.92,
    x2: 288.51,
    y2: 376.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 289.65,
    y1: 276.6,
    x2: 280.49,
    y2: 464.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 386.34,
    y1: 204.75,
    x2: 391.48,
    y2: 191.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 363.5,
    y1: 288.56,
    x2: 456.1,
    y2: 114.46,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 405.87,
    y1: 224.74,
    x2: 447.21,
    y2: 224.51,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 405.9,
    y1: 230.08,
    x2: 447.24,
    y2: 229.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 421.95,
    y1: 278.04,
    x2: 424.43,
    y2: 158.62,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 423.18,
    y1: 226.74,
    x2: 375.7,
    y2: 216.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 334.86,
    y1: 248.38,
    x2: 276.57,
    y2: 177.86,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 324.86,
    y1: 223.24,
    x2: 271.36,
    y2: 227.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 490.76,
    y1: 282.56,
    x2: 436.9,
    y2: 134.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 257.24,
    y1: 250.67,
    x2: 257.65,
    y2: 258.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 252.6,
    y1: 284.76,
    x2: 272.8,
    y2: 228.42,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 257.67,
    y1: 240.73,
    x2: 256.9,
    y2: 256.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 257.62,
    y1: 240.73,
    x2: 256.86,
    y2: 256.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 257.5,
    y1: 241.91,
    x2: 257.44,
    y2: 245.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 256.69,
    y1: 245.37,
    x2: 258.4,
    y2: 236.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 257.36,
    y1: 248.46,
    x2: 257.6,
    y2: 243.68,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 257.13,
    y1: 253.99,
    x2: 258.26,
    y2: 242.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 257.35,
    y1: 256.77,
    x2: 257.61,
    y2: 269.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-1.95 -54.67)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "327.47 343.8 356.91 184.84 386.35 343.8 327.47 343.8",
    fill: "#2c7be5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 390.22,
    y1: 207.04,
    x2: 300.21,
    y2: 221.22,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 363.03,
    y1: 211.8,
    x2: 290.04,
    y2: 205.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 350.81,
    y1: 224.32,
    x2: 360.38,
    y2: 133.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 300.2,
    y1: 241.38,
    x2: 300.79,
    y2: 303.15,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 275.8,
    y1: 242.96,
    x2: 296.79,
    y2: 236.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 320.03,
    y1: 266.62,
    x2: 359.95,
    y2: 276.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 429.17,
    y1: 249.81,
    x2: 425.74,
    y2: 319.14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 431.39,
    y1: 286.93,
    x2: 407.06,
    y2: 165.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 497.87,
    y1: 222.12,
    x2: 496.46,
    y2: 197.31,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 486.15,
    y1: 210.95,
    x2: 508.57,
    y2: 210.95,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 512.17,
    y1: 301.65,
    x2: 463.63,
    y2: 140.42,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 286.23,
    y1: 304.02,
    x2: 286.23,
    y2: 264.34,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 108.97,
    y1: 158.06,
    x2: 138.02,
    y2: 75.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 91.21,
    y1: 290.72,
    x2: 93.1,
    y2: 166.47,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 91.76,
    y1: 171.45,
    x2: 92.47,
    y2: 119.71,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 91.63,
    y1: 279.95,
    x2: 91.63,
    y2: 83.89,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 219.08,
    y1: 216.85,
    x2: 220.23,
    y2: 193.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 217.23,
    y1: 279.22,
    x2: 217.23,
    y2: 207.17,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 216.81,
    y1: 236.97,
    x2: 217.88,
    y2: 199.58,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 211.52,
    y1: 312.58,
    x2: 226.17,
    y2: 263.68,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 122.47,
    y1: 259.62,
    x2: 205.14,
    y2: 178.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 111.39,
    y1: 127.73,
    x2: 112.34,
    y2: 93.71,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 112.58,
    y1: 153.43,
    x2: 112.58,
    y2: 125.26,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 113.49,
    y1: 226.31,
    x2: 110.18,
    y2: 180.95,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 112.63,
    y1: 190.56,
    x2: 111.57,
    y2: 153,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 228.68,
    y1: 209.83,
    x2: 228.15,
    y2: 190.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 229.07,
    y1: 221.77,
    x2: 228.54,
    y2: 209.84,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 229.17,
    y1: 265.21,
    x2: 227.87,
    y2: 237.81,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 228.26,
    y1: 243.97,
    x2: 229.14,
    y2: 225.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 239.66,
    y1: 218.46,
    x2: 239.22,
    y2: 188.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 239.64,
    y1: 237.76,
    x2: 241.06,
    y2: 197.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 246.15,
    y1: 310.9,
    x2: 230.09,
    y2: 201.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 136.73,
    y1: 146.36,
    x2: 140.27,
    y2: 97.81,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 132.54,
    y1: 176.52,
    x2: 132.19,
    y2: 113.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 131.54,
    y1: 291.34,
    x2: 133.43,
    y2: 167.08,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 113.27,
    y1: 291.94,
    x2: 111.49,
    y2: 338.78,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 229.11,
    y1: 303.58,
    x2: 228.6,
    y2: 326.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 258.51,
    y1: 248.57,
    x2: 301.44,
    y2: 483.46,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sans Fransisco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    width: 561.27,
    height: 294.81,
    fill: "#2c7be5",
    opacity: 0.32,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.22,128.84a12,12,0,0,1-1.32,2.43c-.74,1.55-.33,3.53-1.34,4.92s-2.89,1.57-4.57,1.65c-18.88.94-37.79,0-56.68.73-18.35.69-36.73,2.91-55,1.79a82.13,82.13,0,0,1-2.94-16.12,97.41,97.41,0,0,0,8.84-7.44C87.8,108.28,96,99.31,104.65,90.87A17.65,17.65,0,0,1,118,94.12a2.71,2.71,0,0,0,1.55.74A3.17,3.17,0,0,0,121,94.3a5.9,5.9,0,0,1,3.26-.72,19.16,19.16,0,0,1,3.55.87,14.8,14.8,0,0,0,6.45.44c4.18-.66,7.93-3.28,12.16-3.49a11.05,11.05,0,0,1,9,4.1,5.47,5.47,0,0,1,7,2c.3.52.56,1.15,1.1,1.39A3.58,3.58,0,0,0,165,99a3.32,3.32,0,0,1,3.13,2.46,5.1,5.1,0,0,1,5.57.12,14.84,14.84,0,0,1,4,4.28q6.93,9.75,13.42,19.77A4.52,4.52,0,0,1,192.22,128.84Z",
    transform: "translate(-1.95 -54.67)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.38,217.73h0a134.44,134.44,0,0,1-4.53,22.61c-31.32,1.92-62.83-1.88-94.25-3-32.36-1.22-64.78.35-97.11-1.26-2.88-.14-6.15-.51-7.84-2.84s-1-5.75-2.29-8.41c-.68-1.44-1.93-2.61-2.25-4.16-.4-1.95.72-3.84,1.78-5.49Q332,198,343.9,181.27c2-2.75,4-5.57,6.9-7.33s6.83-2.23,9.55-.21a5.66,5.66,0,0,1,5.36-4.22,6.33,6.33,0,0,0,2.57-.15c.93-.42,1.36-1.48,1.87-2.37a9.37,9.37,0,0,1,12-3.49,18.91,18.91,0,0,1,15.47-7c7.25.34,13.68,4.84,20.84,6a25.88,25.88,0,0,0,11.06-.76,31.4,31.4,0,0,1,6.06-1.5,10.23,10.23,0,0,1,5.59,1.23,5.58,5.58,0,0,0,2.41,1,4.68,4.68,0,0,0,2.66-1.28,30.15,30.15,0,0,1,26.31-4.77,12.16,12.16,0,0,0,4.34.83c2.06-.17,3.78-1.55,5.44-2.77.46-.34.93-.67,1.4-1h0a137.78,137.78,0,0,1,16,18.43C510.22,186.33,517.71,202.82,527.38,217.73Z",
    transform: "translate(-1.95 -54.67)",
    fill: "url(#linear-gradient-2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.15,
    y: 286.27,
    width: 562.23,
    height: 78.7,
    fill: "#2c7be5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15,
    y: 286.27,
    width: 562.23,
    height: 78.7,
    opacity: 0.58,
    fill: "url(#linear-gradient-3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15,
    y: 286.27,
    width: 562.23,
    height: 78.7,
    fill: "url(#linear-gradient-4)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 462.24,
    y: 148.63,
    width: 33.83,
    height: 128.95,
    fill: "#2c7be5",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.77,
    y: 161.87,
    width: 8.89,
    height: 126.97,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.63,
    y: 173.51,
    width: 6.14,
    height: 115.34,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.21,
    y: 178.52,
    width: 7.42,
    height: 110.32,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.66,
    y: 173.51,
    width: 6.14,
    height: 115.34,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.79,
    y: 178.52,
    width: 7.65,
    height: 110.32,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.77,
    y: 166.32,
    width: 8.78,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.77,
    y: 171.39,
    width: 8.78,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.42,
    y: 176.47,
    width: 21.27,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 181.55,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 186.63,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 191.71,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 196.79,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 201.87,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 206.95,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 212.03,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 217.1,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 222.18,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 227.26,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 232.34,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 237.42,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 242.5,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 247.58,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 252.66,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 257.73,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 262.81,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 267.89,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 272.97,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 278.05,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.28,
    y: 283.13,
    width: 34.07,
    height: 2.75,
    fill: "#2c7be5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.85,
    y: 184.25,
    width: 6.92,
    height: 98.86,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.07,
    y: 193.31,
    width: 4.78,
    height: 89.8,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.29,
    y: 197.21,
    width: 5.78,
    height: 85.9,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.77,
    y: 193.31,
    width: 4.78,
    height: 89.8,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.55,
    y: 197.21,
    width: 5.77,
    height: 85.9,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.85,
    y: 187.71,
    width: 6.84,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.85,
    y: 191.66,
    width: 6.84,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.91,
    y: 195.62,
    width: 16.56,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 199.57,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 203.53,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 207.48,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 211.44,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 215.39,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 219.35,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 223.3,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 227.26,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 231.21,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 235.16,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 239.12,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 243.07,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 247.03,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 250.98,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 254.94,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 258.89,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 262.85,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 266.8,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 270.75,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 274.71,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.13,
    y: 278.66,
    width: 27.19,
    height: 2.14,
    fill: "#2c7be5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "435.07 305.3 463.27 305.3 463.27 243.86 435.07 229.88 435.07 305.3",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.64,
    y: 240.64,
    width: 44.76,
    height: 64.66,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.5,
    y: 232.21,
    width: 27.91,
    height: 9.02,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.88,
    y: 226.99,
    width: 44.76,
    height: 78.31,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.32,
    y: 216.07,
    width: 27.89,
    height: 10.92,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.48 198.51 279.48 216.07 295.04 216.07 295.04 198.51 287.28 190.83 279.48 198.51",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.95,
    y: 268.05,
    width: 22.36,
    height: 4.56,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.87 263.49 410.87 268.05 423.36 268.05 423.36 263.49 417.14 258.5 410.87 263.49",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.8,
    y: 255.77,
    width: 35.9,
    height: 49.53,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.56,
    y: 248.85,
    width: 22.38,
    height: 6.91,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.53 241.95 148.53 248.85 161 248.85 161 241.95 154.77 234.38 148.53 241.95",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.3 266.48 249.3 305.3 264.88 305.3 264.88 266.48 257.1 223.99 249.3 266.48",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121 305.3 165.76 305.3 165.76 265.14 121 256 121 305.3",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.9 305.3 269.1 305.3 269.1 265.14 240.9 256 240.9 305.3",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.46,
    y: 239.2,
    width: 44.78,
    height: 66.09,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.92,
    y: 229.98,
    width: 27.89,
    height: 9.22,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 264.52,
    width: 44.76,
    height: 40.78,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.44,
    y: 258.83,
    width: 27.89,
    height: 5.69,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.6 249.68 14.6 258.83 30.16 258.83 30.16 249.68 22.38 239.67 14.6 249.68",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.71,
    y: 272.6,
    width: 35.89,
    height: 32.69,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.47,
    y: 268.04,
    width: 22.35,
    height: 4.56,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.41 263.49 184.41 268.04 196.91 268.04 196.91 263.49 190.66 258.5 184.41 263.49",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.01,
    y: 239.19,
    width: 35.88,
    height: 66.11,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.76,
    y: 220.31,
    width: 22.36,
    height: 18.88,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.72 220.74 216.72 229.96 229.21 229.96 229.21 220.74 222.95 210.65 216.72 220.74",
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.88 274.04 99.88 305.3 115.45 305.3 115.45 274.04 107.66 239.82 99.88 274.04",
    fill: "#2c7be5"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 197.82,
    width: 17.94,
    height: 4.6,
    fill: "#2c7be5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 197.82,
    width: 17.94,
    height: 4.6,
    opacity: 0.58,
    fill: "url(#linear-gradient-5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 373.19,
    y: 202.42,
    width: 29.7,
    height: 80.02,
    fill: "#2c7be5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 373.19,
    y: 202.42,
    width: 29.7,
    height: 80.02,
    opacity: 0.58,
    fill: "url(#linear-gradient-6)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 206.15,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 206.15,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 206.15,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 206.15,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 379.89,
    y: 198.78,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 385.59,
    y: 198.78,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 391.3,
    y: 198.78,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 206.15,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 209.53,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 209.53,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 209.53,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 209.53,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 209.53,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 212.9,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 212.9,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 212.9,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 212.9,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 212.9,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 216.28,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 216.28,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 216.28,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 216.28,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 216.28,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 219.66,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 219.66,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 219.66,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 219.66,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 219.66,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 223.04,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 223.04,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 223.04,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 223.04,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 223.04,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 226.42,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 226.42,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 226.42,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 226.42,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 226.42,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 229.79,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 229.79,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 229.79,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 229.79,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 229.79,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 233.17,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 233.17,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 233.17,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 233.17,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 233.17,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 236.55,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 236.55,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 236.55,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 236.55,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 236.55,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 239.93,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 239.93,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 239.93,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 239.93,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 239.93,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 243.3,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 243.3,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 243.3,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 243.3,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 243.3,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 246.68,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 246.68,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 246.68,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 246.68,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 246.68,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 250.06,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 250.06,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 250.06,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 250.06,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 250.06,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 253.44,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 253.44,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 253.44,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 253.44,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 253.44,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 256.81,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 256.81,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 256.81,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 256.81,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 256.81,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 260.19,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 260.19,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 260.19,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 260.19,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 260.19,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 263.57,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 263.57,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 263.57,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 263.57,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 263.57,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 266.95,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 266.95,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 266.95,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 266.95,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 266.95,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 270.32,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 270.32,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 270.32,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 270.32,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 270.32,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 374.24,
    y: 273.7,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 379.94,
    y: 273.7,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 385.65,
    y: 273.7,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 391.36,
    y: 273.7,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 397.07,
    y: 273.7,
    width: 4.89,
    height: 2.68,
    fill: "#2c7be5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "373.19 202.42 373.19 282.44 402.89 282.44 402.89 251.22 379.13 202.42 373.19 202.42",
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 418.87,
    y: 166.85,
    width: 8.09,
    height: 115.59,
    fill: "#2c7be5"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 412.81,
    y: 177.44,
    width: 6.06,
    height: 105,
    fill: "#2c7be5"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 406.53,
    y: 182.69,
    width: 6.76,
    height: 99.75,
    fill: "#2c7be5"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 177.44,
    width: 5.59,
    height: 105,
    fill: "#2c7be5"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 418.87,
    y: 166.85,
    width: 8.09,
    height: 115.59,
    opacity: 0.58,
    fill: "url(#linear-gradient-7)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 177.44,
    width: 5.59,
    height: 105,
    opacity: 0.58,
    fill: "url(#linear-gradient-8)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 432.03,
    y: 177.5,
    width: 0.52,
    height: 104.97,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 418.21,
    y: 177.44,
    width: 0.67,
    height: 104.97,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 412.16,
    y: 182.73,
    width: 0.64,
    height: 99.74,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 426.48,
    y: 166.83,
    width: 0.49,
    height: 115.64,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 422.5,
    y: 166.83,
    width: 0.42,
    height: 115.64,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 432.55,
    y: 182.69,
    width: 6.96,
    height: 99.75,
    fill: "#2c7be5"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 406.53,
    y: 182.69,
    width: 33.23,
    height: 75.72,
    opacity: 0.58,
    fill: "url(#linear-gradient-9)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 418.87,
    y: 169.84,
    width: 8,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 418.87,
    y: 174.46,
    width: 8,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 413.09,
    y: 180.14,
    width: 19.36,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 184.77,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 189.39,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 194.01,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 198.64,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 203.26,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 207.88,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 212.51,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 217.13,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 221.76,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 226.38,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 231,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 235.63,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 240.25,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 244.87,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 249.5,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 254.12,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 258.75,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 263.37,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 267.99,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 272.62,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 407.51,
    y: 277.24,
    width: 31.02,
    height: 2.5,
    fill: "#2c7be5"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 438.99,
    y: 182.62,
    width: 0.52,
    height: 99.66,
    fill: "#2c7be5",
    opacity: 0.3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "421.13 182.65 421.13 166.85 418.87 166.85 418.87 176.96 412.81 176.96 412.81 182.65 406.53 182.65 406.53 282.44 439.51 182.62 432.45 182.65 421.13 182.65",
    fill: "url(#linear-gradient-10)"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 298.53,
    y: 169.62,
    width: 34.56,
    height: 111.42,
    fill: "#2c7be5"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 298.53,
    y: 169.62,
    width: 34.56,
    height: 111.42,
    opacity: 0.58,
    fill: "url(#linear-gradient-11)"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 300.42,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 303.11,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 305.79,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 308.47,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 311.16,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 313.84,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 316.52,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 319.2,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 321.89,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 324.57,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 327.25,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 329.94,
    y: 173.6,
    width: 1.58,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 310.76,
    y: 165.55,
    width: 7.34,
    height: 4.08,
    fill: "#2c7be5"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 320.78,
    y: 167.59,
    width: 3.79,
    height: 2.04,
    fill: "#2c7be5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "298.53 281.04 320.78 169.62 298.53 169.62 298.53 281.04",
    fill: "url(#linear-gradient-12)"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 448.6,
    y: 170.16,
    width: 43.1,
    height: 111.42,
    fill: "#2c7be5"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 448.6,
    y: 170.16,
    width: 43.1,
    height: 111.42,
    opacity: 0.58,
    fill: "url(#linear-gradient-13)"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 450.96,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 454.31,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 457.65,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 464.34,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 467.69,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 471.03,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 474.38,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 477.73,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 481.07,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 484.42,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 487.76,
    y: 174.13,
    width: 1.97,
    height: 105.98,
    fill: "#2c7be5"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 463.85,
    y: 166.08,
    width: 9.15,
    height: 4.08,
    fill: "#2c7be5"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 476.35,
    y: 168.12,
    width: 4.72,
    height: 2.04,
    fill: "#2c7be5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.7 281.58 491.7 170.16 448.6 281.58 491.7 281.58",
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 395.19,
    y: 252.18,
    width: 65.9,
    height: 37.01,
    fill: "#2c7be5"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 252.26,
    y: 252.02,
    width: 10.43,
    height: 6.69,
    fill: "#2c7be5"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 252.26,
    y: 252.02,
    width: 10.43,
    height: 6.69,
    fill: "url(#linear-gradient-14)"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 252.26,
    y: 255.35,
    width: 10.43,
    height: 31.62,
    fill: "#2c7be5"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 252.26,
    y: 255.35,
    width: 10.43,
    height: 31.62,
    opacity: 0.58,
    fill: "url(#linear-gradient-15)"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 254.12,
    y: 244.05,
    width: 6.72,
    height: 1.06,
    fill: "#2c7be5"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 254.71,
    y: 243.18,
    width: 5.54,
    height: 0.88,
    fill: "#2c7be5"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 254.12,
    y: 244.05,
    width: 6.72,
    height: 1.06,
    fill: "url(#linear-gradient-16)"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 254.71,
    y: 243.18,
    width: 5.54,
    height: 0.88,
    fill: "url(#linear-gradient-17)"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 255.33,
    y: 242.5,
    width: 4.31,
    height: 0.68,
    fill: "#2c7be5"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 255.33,
    y: 242.5,
    width: 4.31,
    height: 0.68,
    opacity: 0.58,
    fill: "url(#linear-gradient-18)"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 255.86,
    y: 241.99,
    width: 3.24,
    height: 0.55,
    fill: "#2c7be5"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 256.65,
    y: 236.97,
    width: 1.66,
    height: 1.24,
    fill: "#2c7be5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "257.18 237.03 257.78 237.03 257.48 232.5 257.18 237.03",
    fill: "#2c7be5"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 256.22,
    y: 238.2,
    width: 2.51,
    height: 6.29,
    fill: "#2c7be5"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 256.22,
    y: 238.2,
    width: 2.51,
    height: 6.29,
    fill: "url(#linear-gradient-19)"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 253.63,
    y: 245.11,
    width: 7.67,
    height: 2.56,
    fill: "#2c7be5"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 253.63,
    y: 245.11,
    width: 7.67,
    height: 2.56,
    opacity: 0.58,
    fill: "url(#linear-gradient-20)"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 258.02,
    y: 236.97,
    width: 0.29,
    height: 1.24,
    fill: "#2c7be5"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 258.29,
    y: 238.2,
    width: 0.45,
    height: 3.78,
    fill: "#2c7be5"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 256.65,
    y: 236.97,
    width: 0.29,
    height: 1.24,
    fill: "#2c7be5"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 255.86,
    y: 241.99,
    width: 0.29,
    height: 0.51,
    fill: "#2c7be5"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 255.33,
    y: 242.5,
    width: 0.29,
    height: 0.67,
    fill: "#2c7be5"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 254.71,
    y: 243.17,
    width: 0.29,
    height: 0.88,
    fill: "#2c7be5"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 254.12,
    y: 244.05,
    width: 0.29,
    height: 1.05,
    fill: "#2c7be5"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 258.81,
    y: 241.99,
    width: 0.29,
    height: 0.51,
    fill: "#2c7be5"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 259.34,
    y: 242.5,
    width: 0.29,
    height: 0.67,
    fill: "#2c7be5"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 259.96,
    y: 243.17,
    width: 0.29,
    height: 0.88,
    fill: "#2c7be5"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 260.55,
    y: 244.05,
    width: 0.29,
    height: 1.05,
    fill: "#2c7be5"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 256.22,
    y: 238.2,
    width: 0.29,
    height: 3.78,
    fill: "#2c7be5"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 259.98,
    y: 252.67,
    width: 0.66,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 261.2,
    y: 252.67,
    width: 0.66,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 260.47,
    y: 252.67,
    width: 0.16,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 261.69,
    y: 252.67,
    width: 0.16,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 253.23,
    y: 252.67,
    width: 0.66,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 254.46,
    y: 252.67,
    width: 0.66,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 253.73,
    y: 252.67,
    width: 0.16,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 254.93,
    y: 252.67,
    width: 0.18,
    height: 2.11,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 252.82,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 253.93,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 255.04,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 253.27,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 254.38,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 255.47,
    y: 265.41,
    width: 0.17,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 259.43,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 260.54,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 261.65,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 259.88,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 260.99,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 262.08,
    y: 265.41,
    width: 0.17,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 256.14,
    y: 252.68,
    width: 0.59,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 257.24,
    y: 252.68,
    width: 0.59,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 258.34,
    y: 252.68,
    width: 0.59,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 256.58,
    y: 252.68,
    width: 0.15,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 257.68,
    y: 252.68,
    width: 0.15,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 258.77,
    y: 252.68,
    width: 0.16,
    height: 2.1,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 254.12,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 255.17,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 256.22,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 257.27,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 258.33,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 259.38,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 260.43,
    y: 246.2,
    width: 0.43,
    height: 1.47,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 252.82,
    y: 247.67,
    width: 9.42,
    height: 4.35,
    fill: "#2c7be5"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 252.82,
    y: 247.67,
    width: 9.42,
    height: 4.35,
    opacity: 0.58,
    fill: "url(#linear-gradient-21)"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 256.13,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 257.24,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 258.34,
    y: 265.41,
    width: 0.6,
    height: 2.14,
    fill: "#2c7be5"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 256.58,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 257.68,
    y: 265.41,
    width: 0.15,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 258.77,
    y: 265.41,
    width: 0.17,
    height: 2.14,
    fill: "#2c7be5",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.43,
    cy: 260.5,
    r: 2.88,
    fill: "#2c7be5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.43,
    cy: 260.5,
    r: 2.88,
    fill: "url(#linear-gradient-22)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.52 289.13 354.96 130.16 384.4 289.13 325.52 289.13",
    fill: "#2c7be5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 171.73,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 175.93,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.71 289.73 384.59 289.73 355.15 130.76 325.71 289.73",
    opacity: 0.58,
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 180.13,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 184.33,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 188.53,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 192.73,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 196.93,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 201.13,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 205.33,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 209.53,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 213.73,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 217.92,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 222.12,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 226.32,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 230.52,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 234.72,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 238.92,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 243.12,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 247.32,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 251.52,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 255.72,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 259.92,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 264.12,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 268.32,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 272.52,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 276.72,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 280.91,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.23,
    y: 285.11,
    width: 68.65,
    height: 1.83,
    fill: "#2c7be5"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "344.53 289.19 354.8 130.16 325.36 289.19 344.53 289.19",
    fill: "url(#linear-gradient-24)"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 348.61,
    y: 158.48,
    width: 12.81,
    height: 51.6,
    fill: "#2c7be5"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 348.61,
    y: 158.48,
    width: 12.81,
    height: 51.6,
    fill: "url(#linear-gradient-25)"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 359.97,
    y: 158.48,
    width: 1.45,
    height: 51.64,
    fill: "#2c7be5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.36 289.19 355.69 289.19 332.64 249.88 325.36 289.19",
    fill: "#2c7be5",
    opacity: 0.2
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 273.96,
    y: 247.68,
    width: 53,
    height: 41.52,
    fill: "#2c7be5"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 273.96,
    y: 247.68,
    width: 53,
    height: 41.52,
    opacity: 0.58,
    fill: "url(#linear-gradient-26)"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 249.46,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 252.39,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 255.31,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 258.23,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 261.15,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 264.07,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 266.99,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 269.91,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 272.84,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 275.76,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 278.68,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 281.6,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 276.05,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 282.31,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 294.82,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 301.07,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 313.58,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 319.84,
    y: 284.52,
    width: 5.16,
    height: 1.75,
    fill: "#2c7be5"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 274.92,
    y: 234.34,
    width: 14.09,
    height: 13.34,
    fill: "#2c7be5"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 274.92,
    y: 234.34,
    width: 14.09,
    height: 13.34,
    opacity: 0.58,
    fill: "url(#linear-gradient-27)"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 270.66,
    y: 242.25,
    width: 23.13,
    height: 2.27,
    fill: "#2c7be5"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 270.66,
    y: 236.4,
    width: 23.13,
    height: 3.78,
    fill: "#2c7be5"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 274.92,
    y: 231.52,
    width: 6.74,
    height: 2.82,
    fill: "#2c7be5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.95 289.19 329.63 289.19 329.63 251.62 326.95 247.57 326.95 289.19",
    fill: "#2c7be5"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.95 289.19 329.63 289.19 329.63 251.62 326.95 247.57 326.95 289.19",
    opacity: 0.58,
    fill: "url(#linear-gradient-28)"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 395.19,
    y: 252.18,
    width: 65.9,
    height: 37.01,
    opacity: 0.58,
    fill: "url(#linear-gradient-29)"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 253.77,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 256.38,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 258.98,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 261.59,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 264.19,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 266.8,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 269.4,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 272.01,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 274.61,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 277.21,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 279.82,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 282.42,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 397.79,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 405.57,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 413.35,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 421.13,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 428.91,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 436.69,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 444.46,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 452.24,
    y: 285.03,
    width: 6.41,
    height: 1.56,
    fill: "#2c7be5"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.19 289.19 461.09 252.18 395.19 252.18 395.19 289.19",
    fill: "url(#linear-gradient-30)"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 486.15,
    y: 210.95,
    width: 22.42,
    height: 4.25,
    fill: "#2c7be5"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 486.15,
    y: 210.95,
    width: 22.42,
    height: 4.25,
    opacity: 0.58,
    fill: "url(#linear-gradient-31)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 508.57,
    y1: 210.95,
    x2: 486.15,
    y2: 210.95,
    opacity: 0.58,
    fill: "url(#linear-gradient-32)"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 478.72,
    y: 215.2,
    width: 37.12,
    height: 73.99,
    fill: "#2c7be5"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 478.72,
    y: 215.2,
    width: 37.12,
    height: 73.99,
    opacity: 0.58,
    fill: "url(#linear-gradient-33)"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 218.65,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 218.65,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 218.65,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 218.65,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 487.09,
    y: 211.83,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 494.23,
    y: 211.83,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 501.36,
    y: 211.83,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 218.65,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 221.77,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 221.77,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 221.77,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 221.77,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 221.77,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 224.89,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 224.89,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 224.89,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 224.89,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 224.89,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 228.02,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 228.02,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 228.02,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 228.02,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 228.02,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 231.14,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 231.14,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 231.14,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 231.14,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 231.14,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 234.26,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 234.26,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 234.26,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 234.26,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 234.26,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 237.39,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 237.39,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 237.39,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 237.39,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 237.39,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 240.51,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 240.51,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 240.51,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 240.51,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 240.51,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 243.64,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 243.64,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 243.64,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 243.64,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 243.64,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 246.76,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 246.76,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 246.76,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 246.76,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 246.76,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 249.88,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 249.88,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 249.88,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 249.88,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 249.88,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 253.01,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 253.01,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 253.01,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 253.01,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 253.01,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 256.13,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 256.13,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 256.13,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 256.13,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 256.13,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 259.25,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 259.25,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 259.25,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 259.25,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 259.25,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 262.38,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 262.38,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 262.38,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 262.38,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 262.38,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 265.5,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 265.5,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 265.5,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 265.5,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 265.5,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 268.62,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 268.62,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 268.62,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 268.62,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 268.62,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 271.75,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 271.75,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 271.75,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 271.75,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 271.75,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 274.87,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 274.87,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 274.87,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 274.87,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 274.87,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 277.99,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 277.99,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 277.99,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 277.99,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 277.99,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 480.03,
    y: 281.12,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 487.17,
    y: 281.12,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 494.3,
    y: 281.12,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 501.43,
    y: 281.12,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 508.57,
    y: 281.12,
    width: 6.11,
    height: 2.48,
    fill: "#2c7be5"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.72 289.19 515.85 289.19 515.85 215.2 508.57 215.2 478.72 289.19",
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 243.26,
    y: 283.07,
    width: 75.94,
    height: 6.12,
    fill: "#2c7be5"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15,
    y: 282.37,
    width: 560.17,
    height: 8.42,
    fill: "#2c7be5"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 6.15,
    y: 282.37,
    width: 560.17,
    height: 8.42,
    opacity: 0.58,
    fill: "url(#linear-gradient-34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70,213.82a290.27,290.27,0,0,0,24-49.64c5.32,17.85,45.94,151,75.48,151,28.47,0,47-50.31,50.43-60.44,1.88,5.31,8,22.49,14.35,39.48,15.51,41.47,17.28,41.47,18.23,41.47v-1a.44.44,0,0,1,.15,0c-3-1.6-20.9-49.88-32.18-81.93l-.6-1.71-.54,1.72c-.19.61-19.76,61.38-49.84,61.38S95,163.7,94.58,162.18l-.53-1.82-.61,1.8c-.35,1-35.81,102.25-91.49,102.25v1C25.4,265.39,49.15,247.56,70,213.82Z",
    transform: "translate(-1.95 -54.67)",
    fill: "#2c7be5"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 89.15,
    y: 107.33,
    width: 5.8,
    height: 197.57,
    fill: "#2c7be5"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 89.15,
    y: 107.33,
    width: 5.8,
    height: 197.57,
    opacity: 0.58,
    fill: "url(#linear-gradient-35)"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 85.46,
    y: 165.14,
    width: 13.19,
    height: 139.59,
    opacity: 0.58,
    fill: "url(#linear-gradient-36)"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 85.46,
    y: 165.14,
    width: 1.25,
    height: 139.59,
    fill: "#2c7be5"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 95.29,
    y: 165.14,
    width: 3.34,
    height: 85.19,
    fill: "#2c7be5"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 87.57,
    y: 135.09,
    width: 8.98,
    height: 30.06,
    fill: "#2c7be5"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 87.57,
    y: 135.09,
    width: 8.98,
    height: 30.06,
    opacity: 0.58,
    fill: "url(#linear-gradient-37)"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 104.03,
    width: 3.18,
    height: 4.4,
    fill: "#2c7be5"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 93.22,
    y: 107.33,
    width: 1.74,
    height: 27.75,
    fill: "#2c7be5"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 94.81,
    y: 135.08,
    width: 1.74,
    height: 30.07,
    fill: "#2c7be5"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 89.29,
    y: 107.33,
    width: 0.86,
    height: 27.75,
    fill: "#2c7be5"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 87.57,
    y: 135.08,
    width: 0.88,
    height: 30.07,
    fill: "#2c7be5"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 85.46,
    y: 248.16,
    width: 13.19,
    height: 56.57,
    fill: "#2c7be5"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 85.46,
    y: 165.14,
    width: 13.19,
    height: 139.59,
    fill: "#2c7be5"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 86.71,
    y: 165.14,
    width: 9.84,
    height: 139.59,
    opacity: 0.58,
    fill: "url(#linear-gradient-38)"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 215.58,
    y: 198.29,
    width: 3.3,
    height: 111.25,
    fill: "#2c7be5"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 215.58,
    y: 198.29,
    width: 3.3,
    height: 111.25,
    opacity: 0.58,
    fill: "url(#linear-gradient-39)"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 230.84,
    width: 7.5,
    height: 78.6,
    fill: "#2c7be5"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 230.84,
    width: 7.5,
    height: 78.6,
    opacity: 0.58,
    fill: "url(#linear-gradient-40)"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 230.84,
    width: 0.71,
    height: 78.61,
    fill: "#2c7be5"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 219.07,
    y: 230.84,
    width: 1.9,
    height: 47.97,
    fill: "#2c7be5"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 217.89,
    y: 198.29,
    width: 0.99,
    height: 15.63,
    fill: "#2c7be5"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 215.65,
    y: 198.29,
    width: 0.49,
    height: 15.63,
    fill: "#2c7be5"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 214.67,
    y: 213.92,
    width: 5.11,
    height: 16.92,
    fill: "#2c7be5"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 214.67,
    y: 213.92,
    width: 5.11,
    height: 16.92,
    opacity: 0.58,
    fill: "url(#linear-gradient-41)"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 216.32,
    y: 196.43,
    width: 1.81,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 218.79,
    y: 213.92,
    width: 0.99,
    height: 16.93,
    fill: "#2c7be5"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 214.67,
    y: 213.92,
    width: 0.5,
    height: 16.93,
    fill: "#2c7be5"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 277.59,
    width: 7.5,
    height: 31.86,
    fill: "#2c7be5"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 213.48,
    y: 277.59,
    width: 7.5,
    height: 31.86,
    opacity: 0.58,
    fill: "url(#linear-gradient-42)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.97 286.38 267.97 283.42 0 210.23 0 236.6 252.82 286.38 267.97 286.38",
    fill: "#2c7be5"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.97 286.38 267.97 283.42 0 210.23 0 236.6 252.82 286.38 267.97 286.38",
    opacity: 0.58,
    fill: "url(#linear-gradient-43)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.97 283.42 0 210.23 0 222.01 267.97 286.38 267.97 283.42",
    fill: "#2c7be5"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 98.65,
    y: 293.59,
    width: 27.4,
    height: 2.58,
    fill: "#2c7be5"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 98.51,
    y: 273.19,
    width: 27.4,
    height: 2.22,
    fill: "#2c7be5"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 252.54,
    width: 27.4,
    height: 2.58,
    fill: "#2c7be5"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.51 292.93 99.28 294.76 127.92 275.92 125.14 274.09 96.51 292.93",
    fill: "#2c7be5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.51 275.92 125.14 294.76 127.92 292.93 99.28 274.09 96.51 275.92",
    fill: "#2c7be5"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 107.54,
    y: 281.35,
    width: 9.35,
    height: 6.15,
    fill: "#2c7be5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.52 272.26 99.3 274.09 127.93 255.25 125.15 253.42 96.52 272.26",
    fill: "#2c7be5"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.52 255.25 125.15 274.09 127.93 272.26 99.3 253.42 96.52 255.25",
    fill: "#2c7be5"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 107.55,
    y: 260.68,
    width: 9.35,
    height: 6.15,
    fill: "#2c7be5"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 94.09,
    y: 109.25,
    width: 35.4,
    height: 8.41,
    fill: "#2c7be5"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 94.09,
    y: 109.25,
    width: 35.4,
    height: 8.41,
    opacity: 0.58,
    fill: "url(#linear-gradient-44)"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 125.18,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 121.95,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 118.72,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 112.26,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 109.02,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 105.79,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 102.56,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 99.33,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 111.29,
    width: 0.86,
    height: 4.38,
    fill: "#2c7be5"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.67 118.36 127.77 120.23 129.49 120.23 129.49 117.67 123.67 117.67 123.67 118.36",
    fill: "#2c7be5"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 120.23 95.81 120.23 99.91 118.36 99.91 117.67 94.09 117.67 94.09 120.23",
    fill: "#2c7be5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.99,
    cy: 107.62,
    rx: 3.09,
    ry: 2.27,
    fill: "#2c7be5"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.93 147.59 127.85 149.46 129.49 149.46 129.49 146.9 123.93 146.9 123.93 147.59",
    fill: "#2c7be5"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.93 137.79 123.93 138.48 129.49 138.48 129.49 135.92 127.85 135.92 123.93 137.79",
    fill: "#2c7be5"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 95.68,
    y: 138.48,
    width: 33.82,
    height: 8.41,
    fill: "#2c7be5"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 95.68,
    y: 138.48,
    width: 33.82,
    height: 8.41,
    opacity: 0.58,
    fill: "url(#linear-gradient-45)"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 125.37,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 122.29,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 119.2,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 116.11,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 113.03,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 109.94,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 103.77,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 100.68,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 140.52,
    width: 0.82,
    height: 4.38,
    fill: "#2c7be5"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.68 149.46 97.32 149.46 101.24 147.59 101.24 146.9 95.68 146.9 95.68 149.46",
    fill: "#2c7be5"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.68 135.92 95.68 138.48 101.24 138.48 101.24 137.79 97.32 135.92 95.68 135.92",
    fill: "#2c7be5"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.65 215.49 126.24 217.84 127.75 217.84 127.75 214.62 122.65 214.62 122.65 215.49",
    fill: "#2c7be5"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.65 203.19 122.65 204.06 127.75 204.06 127.75 200.84 126.24 200.84 122.65 203.19",
    fill: "#2c7be5"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 96.76,
    y: 204.06,
    width: 30.99,
    height: 10.56,
    fill: "#2c7be5"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 96.76,
    y: 204.06,
    width: 30.99,
    height: 10.56,
    opacity: 0.58,
    fill: "url(#linear-gradient-46)"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 123.97,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 121.15,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 118.32,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 112.66,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 109.83,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 104.18,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 101.35,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 98.52,
    y: 206.62,
    width: 0.75,
    height: 5.5,
    fill: "#2c7be5"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.76 217.84 98.27 217.84 101.86 215.49 101.86 214.62 96.76 214.62 96.76 217.84",
    fill: "#2c7be5"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.76 200.84 96.76 204.06 101.86 204.06 101.86 203.19 98.27 200.84 96.76 200.84",
    fill: "#2c7be5"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.49 178.82 126.06 180.9 127.56 180.9 127.56 178.04 122.49 178.04 122.49 178.82",
    fill: "#2c7be5"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.49 167.85 122.49 168.63 127.56 168.63 127.56 165.77 126.06 165.77 122.49 167.85",
    fill: "#2c7be5"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 96.72,
    y: 168.63,
    width: 30.84,
    height: 9.4,
    fill: "#2c7be5"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 96.72,
    y: 168.63,
    width: 30.84,
    height: 9.4,
    opacity: 0.58,
    fill: "url(#linear-gradient-47)"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 123.84,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 121.17,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 115.83,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 113.15,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 110.48,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 107.81,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 105.14,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 102.47,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 99.79,
    y: 170.91,
    width: 0.71,
    height: 4.9,
    fill: "#2c7be5"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.72 180.9 98.22 180.9 101.79 178.82 101.79 178.04 96.72 178.04 96.72 180.9",
    fill: "#2c7be5"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "96.72 165.77 96.72 168.63 101.79 168.63 101.79 167.85 98.22 165.77 96.72 165.77",
    fill: "#2c7be5"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 220.98,
    y: 303.17,
    width: 15.59,
    height: 1.46,
    fill: "#2c7be5"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 220.9,
    y: 291.69,
    width: 15.59,
    height: 1.25,
    fill: "#2c7be5"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 220.91,
    y: 280.06,
    width: 15.59,
    height: 1.46,
    fill: "#2c7be5"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.76 302.8 221.34 303.83 237.63 293.22 236.06 292.19 219.76 302.8",
    fill: "#2c7be5"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.76 293.22 236.06 303.83 237.63 302.8 221.34 292.19 219.76 293.22",
    fill: "#2c7be5"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 296.28,
    width: 5.32,
    height: 3.47,
    fill: "#2c7be5"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.77 291.17 221.35 292.19 237.64 281.58 236.06 280.56 219.77 291.17",
    fill: "#2c7be5"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.77 281.58 236.06 292.19 237.64 291.17 221.35 280.56 219.77 281.58",
    fill: "#2c7be5"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 226.04,
    y: 284.64,
    width: 5.32,
    height: 3.47,
    fill: "#2c7be5"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 218.39,
    y: 199.37,
    width: 20.14,
    height: 4.74,
    fill: "#2c7be5"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 218.39,
    y: 199.37,
    width: 20.14,
    height: 4.74,
    opacity: 0.58,
    fill: "url(#linear-gradient-48)"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 236.08,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 234.24,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 232.4,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 230.56,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 226.88,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 225.05,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 223.21,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 221.37,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 219.53,
    y: 200.52,
    width: 0.49,
    height: 2.47,
    fill: "#2c7be5"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.22 204.5 237.55 205.56 238.53 205.56 238.53 204.11 235.22 204.11 235.22 204.5",
    fill: "#2c7be5"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.39 205.56 219.37 205.56 221.7 204.5 221.7 204.11 218.39 204.11 218.39 205.56",
    fill: "#2c7be5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230,251.85c-1,0-1.76.57-1.76,1.28s.79,1.27,1.76,1.27,1.76-.57,1.76-1.27S230.92,251.85,230,251.85Z",
    transform: "translate(-1.95 -54.67)",
    fill: "#2c7be5"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.37 220.96 237.59 222.01 238.53 222.01 238.53 220.57 235.37 220.57 235.37 220.96",
    fill: "#2c7be5"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.37 215.44 235.37 215.83 238.53 215.83 238.53 214.39 237.59 214.39 235.37 215.44",
    fill: "#2c7be5"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 219.29,
    y: 215.83,
    width: 19.24,
    height: 4.74,
    fill: "#2c7be5"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 219.29,
    y: 215.83,
    width: 19.24,
    height: 4.74,
    opacity: 0.58,
    fill: "url(#linear-gradient-49)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 238.53,
    y1: 215.83,
    x2: 219.29,
    y2: 215.83,
    fill: "#2c7be5"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 236.19,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 234.43,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 232.67,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 230.92,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 229.16,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 227.41,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 225.65,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 223.89,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 222.14,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 220.38,
    y: 216.98,
    width: 0.47,
    height: 2.47,
    fill: "#2c7be5"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.29 222.01 220.22 222.01 222.45 220.96 222.45 220.57 219.29 220.57 219.29 222.01",
    fill: "#2c7be5"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.29 214.39 219.29 215.83 222.45 215.83 222.45 215.44 220.22 214.39 219.29 214.39",
    fill: "#2c7be5"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.64 259.2 236.68 260.52 237.54 260.52 237.54 258.71 234.64 258.71 234.64 259.2",
    fill: "#2c7be5"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.64 252.27 234.64 252.76 237.54 252.76 237.54 250.95 236.68 250.95 234.64 252.27",
    fill: "#2c7be5"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 219.91,
    y: 252.76,
    width: 17.63,
    height: 5.95,
    fill: "#2c7be5"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 219.91,
    y: 252.76,
    width: 17.63,
    height: 5.95,
    opacity: 0.58,
    fill: "url(#linear-gradient-50)"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 235.39,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 233.78,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 232.17,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 230.56,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 228.95,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 227.34,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 225.73,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 224.13,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 222.52,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 220.91,
    y: 254.2,
    width: 0.43,
    height: 3.1,
    fill: "#2c7be5"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.91 260.52 220.76 260.52 222.8 259.2 222.8 258.71 219.91 258.71 219.91 260.52",
    fill: "#2c7be5"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.91 250.95 219.91 252.76 222.8 252.76 222.8 252.27 220.76 250.95 219.91 250.95",
    fill: "#2c7be5"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.55 238.54 236.58 239.72 237.43 239.72 237.43 238.11 234.55 238.11 234.55 238.54",
    fill: "#2c7be5"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.55 232.37 234.55 232.81 237.43 232.81 237.43 231.2 236.58 231.2 234.55 232.37",
    fill: "#2c7be5"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 219.88,
    y: 232.81,
    width: 17.55,
    height: 5.3,
    fill: "#2c7be5"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 219.88,
    y: 232.81,
    width: 17.55,
    height: 5.3,
    opacity: 0.58,
    fill: "url(#linear-gradient-51)"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 235.31,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 233.79,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 232.27,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 230.75,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 229.23,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 227.71,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 226.19,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 224.67,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 223.15,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 221.63,
    y: 234.09,
    width: 0.41,
    height: 2.76,
    fill: "#2c7be5"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.88 239.72 220.74 239.72 222.77 238.54 222.77 238.11 219.88 238.11 219.88 239.72",
    fill: "#2c7be5"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.88 231.2 219.88 232.81 222.77 232.81 222.77 232.37 220.74 231.2 219.88 231.2",
    fill: "#2c7be5"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 238.53,
    y: 198.29,
    width: 3.3,
    height: 110.76,
    fill: "#2c7be5"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 238.53,
    y: 198.29,
    width: 3.3,
    height: 110.76,
    opacity: 0.58,
    fill: "url(#linear-gradient-52)"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 213.92,
    width: 5.11,
    height: 16.92,
    fill: "#2c7be5"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 213.92,
    width: 5.11,
    height: 16.92,
    opacity: 0.58,
    fill: "url(#linear-gradient-53)"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 239.45,
    y: 196.43,
    width: 1.81,
    height: 2.48,
    fill: "#2c7be5"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 236.43,
    y: 230.84,
    width: 7.5,
    height: 78.6,
    fill: "#2c7be5"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 236.43,
    y: 230.84,
    width: 7.5,
    height: 78.6,
    opacity: 0.58,
    fill: "url(#linear-gradient-54)"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 240.84,
    y: 198.29,
    width: 0.99,
    height: 15.63,
    fill: "#2c7be5"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 241.75,
    y: 213.92,
    width: 0.99,
    height: 16.93,
    fill: "#2c7be5"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 242.19,
    y: 230.84,
    width: 1.75,
    height: 78.61,
    fill: "#2c7be5"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 236.43,
    y: 230.84,
    width: 0.71,
    height: 78.61,
    fill: "#2c7be5"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 213.92,
    width: 0.5,
    height: 16.93,
    fill: "#2c7be5"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 238.53,
    y: 198.29,
    width: 0.49,
    height: 15.63,
    fill: "#2c7be5"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 129.49,
    y: 107.33,
    width: 5.8,
    height: 196.7,
    fill: "#2c7be5"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 129.49,
    y: 107.33,
    width: 5.8,
    height: 196.7,
    opacity: 0.58,
    fill: "url(#linear-gradient-55)"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 127.91,
    y: 135.09,
    width: 8.98,
    height: 30.06,
    fill: "#2c7be5"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 127.91,
    y: 135.09,
    width: 8.98,
    height: 30.06,
    opacity: 0.58,
    fill: "url(#linear-gradient-56)"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 104.03,
    width: 3.18,
    height: 4.4,
    fill: "#2c7be5"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 165.14,
    width: 13.19,
    height: 139.59,
    fill: "#2c7be5"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 165.14,
    width: 13.19,
    height: 139.59,
    opacity: 0.58,
    fill: "url(#linear-gradient-57)"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 133.56,
    y: 107.33,
    width: 1.74,
    height: 27.75,
    fill: "#2c7be5"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 135.15,
    y: 135.09,
    width: 1.74,
    height: 30.07,
    fill: "#2c7be5"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 135.92,
    y: 165.14,
    width: 3.07,
    height: 139.59,
    fill: "#2c7be5"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 165.14,
    width: 1.25,
    height: 139.59,
    fill: "#2c7be5"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 127.91,
    y: 135.08,
    width: 0.88,
    height: 30.07,
    fill: "#2c7be5"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 129.49,
    y: 107.33,
    width: 0.86,
    height: 27.75,
    fill: "#2c7be5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.72,254.78l-.44-2.48-.72,2.43c-.19.64-19.31,64.07-40.38,64.07-16.86,0-50.52-101.92-66-155.82l-.48-1.67-.66,1.63C133.64,164,89.6,270.82,19.58,270.82v1c37.09,0,66.56-29.55,84.76-54.35a286.73,286.73,0,0,0,30.19-52.62c5.09,17.54,45.61,154.95,66.65,154.95,19.84,0,37-50.64,40.8-62.46,2.82,15.41,15.58,81.26,27.94,81.26v-1C259.62,337.6,246.79,277.81,242.72,254.78Z",
    transform: "translate(-1.95 -54.67)",
    fill: "#2c7be5"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 81.72,
    y: 304.54,
    width: 61.73,
    height: 10.99,
    fill: "#2c7be5"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 81.72,
    y: 304.54,
    width: 61.73,
    height: 10.99,
    opacity: 0.58,
    fill: "url(#linear-gradient-58)"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 119.88,
    y: 304.54,
    width: 2.43,
    height: 10.99,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 113.52,
    y: 304.54,
    width: 2.43,
    height: 10.99,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 304.54,
    width: 2.43,
    height: 10.99,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 100.8,
    y: 304.54,
    width: 2.43,
    height: 10.99,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 94.44,
    y: 304.54,
    width: 2.43,
    height: 10.99,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 133.72,
    y: 304.54,
    width: 9.73,
    height: 10.99,
    fill: "#2c7be5"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 211.35,
    y: 309.34,
    width: 35.12,
    height: 6.19,
    fill: "#2c7be5"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 211.35,
    y: 309.34,
    width: 35.12,
    height: 6.19,
    opacity: 0.58,
    fill: "url(#linear-gradient-59)"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 233.06,
    y: 309.34,
    width: 1.38,
    height: 6.19,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 229.44,
    y: 309.34,
    width: 1.38,
    height: 6.19,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 225.82,
    y: 309.34,
    width: 1.38,
    height: 6.19,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 309.34,
    width: 1.38,
    height: 6.19,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 218.58,
    y: 309.34,
    width: 1.38,
    height: 6.19,
    fill: "#2c7be5",
    opacity: 0.3
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 240.94,
    y: 309.34,
    width: 5.53,
    height: 6.19,
    fill: "#2c7be5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.86,375.83c-100.81-36.66,188-23.76,197-30-11.49-4.5-222.1-.17-234.42-.86a13,13,0,0,0-6,.69c-2.36,1.06-3.79,4.48-5.53,6.39-9.24,10.13-24.81,10.38-38.51,10q-87-2.67-174-1.44c.25,0,10,12.1,12,13.35a37.3,37.3,0,0,0,17.32,6.05C90.67,380.74,250.84,400,264,400c34.3-.08-77.41-21.65-43.21-24.77C240.08,373.49,328,382.44,309.86,375.83Z",
    transform: "translate(-1.95 -54.67)",
    opacity: 0.58,
    fill: "url(#linear-gradient-60)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanFrancisco);
export default __webpack_public_path__ + "static/media/san-francisco.3c32ca01b06d8838a217ef3265b625da.svg";
export { ForwardRef as ReactComponent };